const isIntellia = (organizationName?: string) => (
  organizationName?.toLowerCase() === "intellia-therapeutics"
);

export default isIntellia;
